<template>
  <div class="d-flex" :class="this.$store.state.menuToggle" id="wrapper">
    <TheSidemenu />
    <div id="page-content-wrapper">
      <TheTopmenu />
      <div class="container-fluid text-start">
        <p class="fs-5 my-2">
          {{ this.$route.meta.title }}
        </p>
        <div v-if="!videoSessionData || videoSessionData.is_hidden != 0">
          <i class="fas fa-spinner fa-spin fs-1 mt-3"></i>
        </div>
        <div v-else>
          <div class="fs-6 mb-2">
            {{ videoSessionData.product.name }} جلسه:
            {{ this.$route.params.videoSessionName }}
          </div>
          <div class="row">
            <div class="col-12 col-sm-8 col-md-8">
              <div id="videoFrame">
                <div
                  v-if="videoSessionData.video_session.is_aparat"
                  v-html="decode(videoSessionData.video_session.video_link)"
                ></div>
                <div
                  v-else
                  class="r1_iframe_embed border border-secondary rounded"
                >
                  <iframe
                    :src="decode(videoSessionData.video_session.video_link)"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen="true"
                    webkitallowfullscreen="true"
                    mozallowfullscreen="true"
                  ></iframe>
                </div>
              </div>
              <div class="card my-2">
                <div class="card-header fs-6">دریافت جزوه</div>
                <div
                  v-if="!videoSessionData.files"
                  class="card-body d-flex justify-content-start"
                >
                  این جلسه جزوه ندارد
                </div>
                <div v-else class="card-body d-flex justify-content-start">
                  <div
                    v-for="item in videoSessionData.files"
                    :key="item.id"
                    class="
                      border
                      d-flex
                      justify-content-between
                      m-1
                      p-2
                      rounded-1
                      fs-6
                    "
                  >
                    <a :href="API_STORAGE_URL + item.file_path" target="_blank">
                      <i class="fas fa-download"></i>
                      {{ item.name }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-4 col-md-4">
              <div
                class="card"
                v-if="
                  videoSessionData.video_session.video_session_type == 'offline'
                "
              >
                <div class="card-header fs-5 text-center">
                  کلیه جلسات این محصول
                </div>
                <VideoSessions
                  :productId="Number(videoSessionData.product.id)"
                />
              </div>

              <div v-else class="card border">
                <div class="card-header">چتها</div>
                <div v-if="!chatMessages" class="card-body hs-chat-box">
                  پیامی ارسال نشده است
                </div>
                <div v-else class="card-body hs-chat-box" id="hs-chat-box">
                  <div
                    v-for="(item, index) in chatMessages"
                    :key="index"
                    :class="
                      'text-start p-2 rounded border mb-1 ' +
                      (item.id == this.$store.state.user_id
                        ? 'text-primary'
                        : '')
                    "
                  >
                    <span class="fw-bold"> {{ item.name }}: </span>
                    <span>
                      {{ item.msg }}
                    </span>
                  </div>
                </div>
                <div class="card-footer row g-0">
                  <div class="col-9 col-sm-8 m-0 ps-sm-1 py-1 py-md-0">
                    <input
                      v-model="chatMsg"
                      class="form-control w-100"
                      placeholder="پیام خود را بنویسید ..."
                      @keyup.enter="sendChat"
                    />
                  </div>
                  <div class="col-3 col-sm-4 m-0 my-1 my-sm-0">
                    <a @click="sendChat" class="btn btn-success w-100">
                      ارسال
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TheSidemenu from "../../components/TheSidemenu";
import TheTopmenu from "../../components/TheTopmenu";
import ArefApi from "../../libs/api.js";
import utils from "../../libs/utils";
import VideoSessions from "@/components/VideoSessions";

export default {
  name: "VideoSessionPlay",
  created() {
    this.arefApi = new ArefApi(this);
    this.utils = new utils();
    this.productDetailViedosId = this.$route.params.productDetailViedosId;
    this.API_STORAGE_URL = process.env.VUE_APP_API_STORAGE_URL;
    this.$store.commit("set", ["menuToggle", ""]);
    this.getVideoSessionInfo();
    this.tryReconnectSocket();
    this.checkStatusLoop();
  },
  components: {
    TheSidemenu,
    TheTopmenu,
    VideoSessions,
  },
  data() {
    return {
      videoSessionData: null,
      chatMessages: [],
      chatMsg: null,
      timerHandler: null,
      timerIntervalHandle: null,
      presentationCount: 0,
      videoSessionId: null,
      isSocketConnected: this.$store.state.socket.isConnected,
      statusCheckTimer: null,
    };
  },
  methods: {
    getVideoSessionInfo(status = false) {
      this.arefApi
        .getUserProductVideoSessionInfo(this.productDetailViedosId)
        .then((resp) => {
          this.videoSessionData = resp.data;
          this.videoSessionId = this.videoSessionData.video_session.id;
          if (status) {
            //check status for ending chats
            return;
          }
          if (this.videoSessionData.video_session.ws == "online" || this.videoSessionData.video_session.video_session_type == "online") {
            this.startChat();
            this.onMessage();
          }
          this.sendPresentation();
        })
        .catch((err) => {
          console.log(err);
          //this.utils.showErrors(this, err);
        });
    },
    decode(input) {
      return atob(input);
    },
    startChat() {
      const socketData = {
        Type: "START_MESSAGE",
        Token: this.$store.state.token,
        Data: { video_session_id: Number(this.videoSessionId) },
      };
      this.$socket.sendObj(socketData);
    },
    onMessage() {
      this.$options.sockets.onmessage = (data) => {
        const resivedData = JSON.parse(data.data);
        if (resivedData.Type == "MESSAGE") {
          this.chatMessages = this.chatMessages.concat(resivedData.Data);
        }
      };
    },
    sendChat() {
      if (!this.chatMsg) {
        return;
      }
      if (this.hasRestrictedWord(this.chatMsg)) {
        this.chatMsg = "";
        return;
      }
      const socketData = {
        Type: "MESSAGE",
        Token: this.$store.state.token,
        Data: {
          msg: this.chatMsg,
          video_session_id: Number(this.videoSessionId),
        },
      };
      //console.log("MESSAGE:", socketData);
      this.$socket.sendObj(socketData);
      this.chatMsg = null;
    },
    sendPresentation() {
      if (this.$route.name != "VideoSessionPlay") {
        return;
      }
      const type = this.presentationCount == 0 ? "FIRST_PRESENCE" : "PRESENCE";
      this.presentationCount++;
      const socketData = {
        Type: type,
        Token: this.$store.state.token,
        Data: {
          videoSessionId: Number(this.videoSessionId),
          type: this.videoSessionData.video_session.video_session_type,
          users_id: this.$store.state.user_id,
        },
      };

      if (this.$store.state.socket.isConnected) {
        this.$socket.sendObj(socketData);
      }

      this.timerHandler = setTimeout(this.sendPresentation, 2 * 60 * 1000);
    },
    tryReconnectSocket() {
      this.timerIntervalHandle = setInterval(() => {
        if (
          !this.$store.state.socket.isConnected &&
          this.$store.state.socket.reconnectError
        ) {
          this.$connect();
        }
      }, 10000);
    },
    hasRestrictedWord(inp) {
      const restricted = [
        "کیر",
        "کون",
        "کثافت",
        "کصافت",
        "کسافت",
        "کص",
        "خامنه ای",
        "خمینی",
        "گاییدن",
        "جاکش",
        "کسکش",
        "سکس",
        "دیوص",
        "دیوس",
        "دیوث",
        "آشغال",
        "عوضی",
        "مادر ننه",
        "بی پدر",
        "بی مادر",
        "صکص",
        "پشمام",
        "خوار",
        "کسده",
        "گوز",
        "خیار",
        "پشم",
      ];
      for (let i in restricted) {
        if (inp.indexOf(restricted[i]) >= 0) {
          return true;
        }
      }
      return false;
    },

    checkStatusLoop() {
      this.statusCheckTimer = setInterval(() => {
        this.getVideoSessionInfo(true);
      }, 60000);
    },
  },
  mounted() {
    this.presentationCount = 0;
  },
  updated() {
    const container = document.querySelector("#hs-chat-box");
    if (container) {
      container.scrollTo(0, container.scrollHeight);
    }
  },
  unmounted() {
    if (this.timerIntervalHandle) {
      clearInterval(this.timerIntervalHandle);
    }
    if (this.timerHandler) {
      clearTimeout(this.timerHandler);
    }

    if (this.statusCheckTimer) {
      clearInterval(this.statusCheckTimer);
    }
  },
};
</script>
<style>
.r1_iframe_embed {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: auto;
  padding-top: 56.25%;
}
.r1_iframe_embed iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>